export const GENDERS_ACTIONS = {
    FIND: 'FIND_GENDERS',
    GET: 'GET_GENDERS',
    GET_LIST: 'GET_LIST_GENDERS',
    CHANGE_STATUS: 'CHANGE_STATUS_GENDERS',
    SUCCESS: 'SUCCESS_GENDERS',
    ERROR: 'ERROR_GENDERS',
    CLEAN: 'CLEAN_GENDERS',
}